const NotificationType = {
  Default: 'default',
  Success: 'success',
  Error: 'error',
  Warning: 'warning',
  Info: 'info'
};
export { NotificationType };